import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ExampleRow } from '../../../models/formula-example-row.model';

interface SafeExampleRow {
  safeExpression: SafeHtml;
  exampleText: string;
  safePreviewHTML: SafeHtml;
  result: string;
  layout: 'normal' | 'wide';
}

/**
 * Renders a list of ExampleRow entries as a compact four-column table
 * (Expression | Example | Preview | Result).
 *
 * Used as a dynamic `componentRef` child inside an OverviewCardComponent section property.
 */
@Component({
  selector: 'iot-platform-ui-formula-examples-table',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './formula-examples-table.component.html',
  styleUrls: ['./formula-examples-table.component.scss']
})
export class FormulaExamplesTableComponent {
  readonly rows = input.required<ExampleRow[]>();

  private readonly sanitizer = inject(DomSanitizer);

  /** Maps raw rows to sanitised versions for safe [innerHTML] binding. */
  readonly safeRows = computed<SafeExampleRow[]>(() =>
    this.rows().map((row) => ({
      safeExpression: this.sanitizer.bypassSecurityTrustHtml(row.expression),
      exampleText: row.exampleText,
      safePreviewHTML: this.sanitizer.bypassSecurityTrustHtml(row.previewHTML),
      result: row.result,
      layout: row.layout ?? 'normal'
    }))
  );
}

